import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth, tieneAcceso } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Ordenes from './pages/Ordenes';
import Layout from './components/Layout';
import Consulta from './pages/Consulta';
import Productos from './pages/Productos';
import Inventario from './pages/Inventario';
import Auditoria from './pages/Auditoria';
import Reposicion from './pages/Reposicion';
import Clientes from './pages/Clientes';
import Proveedores from './pages/Proveedores';
import Finanzas from './pages/Finanzas';
import Facturas from './pages/Facturas';
import Banco from './pages/Banco';
import Creditos from './pages/Creditos';
import AuditoriaBodegas from './pages/AuditoriaBodegas';
import Empleados from './pages/Empleados';
import CierreCaja from './pages/CierreCaja';
import VentasDashboard from './pages/VentasDashboard';
import GarantiasModule from './pages/GarantiasModule';
import TareasModule from './pages/TareasModule';
import Vehiculos from './pages/Vehiculos';
import Requerimientos from './pages/Requerimientos';


function ProtectedRoute({ children }) {
  const { usuario } = useAuth();
  const location = useLocation();

  if (!usuario) return <Navigate to="/" replace />;
  if (!tieneAcceso(usuario.rol, location.pathname)) return <Navigate to="/dashboard" replace />;

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={
        <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
      } />
      <Route path="/ordenes" element={
        <ProtectedRoute><Layout><Ordenes /></Layout></ProtectedRoute>
      } />
      <Route path="/consulta" element={
        <ProtectedRoute><Layout><Consulta /></Layout></ProtectedRoute>
      } />
      <Route path="/productos" element={
        <ProtectedRoute><Layout><Productos /></Layout></ProtectedRoute>
      } />
      <Route path="/inventario" element={
        <ProtectedRoute><Layout><Inventario /></Layout></ProtectedRoute>
      } />
      <Route path="/auditoria" element={
        <ProtectedRoute><Layout><Auditoria /></Layout></ProtectedRoute>
      } />
      <Route path="/reposicion" element={
        <ProtectedRoute><Layout><Reposicion /></Layout></ProtectedRoute>
      } />
      <Route path="/clientes" element={
        <ProtectedRoute><Layout><Clientes /></Layout></ProtectedRoute>
      } />
      <Route path="/proveedores" element={
        <ProtectedRoute><Layout><Proveedores /></Layout></ProtectedRoute>
      } />
      <Route path="/finanzas" element={
        <ProtectedRoute><Layout><Finanzas /></Layout></ProtectedRoute>
      } />
      <Route path="/facturas" element={
        <ProtectedRoute><Layout><Facturas /></Layout></ProtectedRoute>
      } />
      <Route path="/banco" element={<ProtectedRoute><Layout><Banco /></Layout></ProtectedRoute>} />
      <Route path="/creditos" element={<ProtectedRoute><Layout><Creditos /></Layout></ProtectedRoute>} />
      <Route path="/bodegas" element={<ProtectedRoute><Layout><AuditoriaBodegas /></Layout></ProtectedRoute>} />
      <Route path="/empleados" element={<ProtectedRoute><Layout><Empleados /></Layout></ProtectedRoute>} />
      <Route path="/cierrecaja" element={<ProtectedRoute><Layout><CierreCaja /></Layout></ProtectedRoute>} />
      <Route path="/ventasdashboard" element={<ProtectedRoute><Layout><VentasDashboard /></Layout></ProtectedRoute>} />
      <Route path="/garantiasmodule" element={<ProtectedRoute><Layout><GarantiasModule /></Layout></ProtectedRoute>} />
      <Route path="/tareas" element={<ProtectedRoute><Layout><TareasModule /></Layout></ProtectedRoute>} />
      <Route path="/vehiculos" element={<ProtectedRoute><Layout><Vehiculos /></Layout></ProtectedRoute>} />
      <Route path="/requerimientos" element={<ProtectedRoute><Layout><Requerimientos /></Layout></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}